import { ImageOptimization } from '@components/image-optimization'
import Link from 'next/link'
import styles from './styles.module.scss'

interface SearchedItemProps {
  id: number
  path?: string
  title: string
  shortContent?: string
  linkTo: string
  thumbnailImage?: {
    path?: string
    alt?: string
  }
  publishedAt: string
}

export const SearchedItem = (props: SearchedItemProps) => {
  return (
    <>
      <div className={styles.container}>
        <Link href={props.linkTo}>
          {props.thumbnailImage && (
            <div className={styles.containerImage}>
              <ImageOptimization
                width="100%"
                height="100%"
                src={props.thumbnailImage.path}
                alt={props.thumbnailImage.alt}
              />
            </div>
          )}

          <div className="max-w-lg mb-2 ">
            <h3 className="text-sm md:text-base font-bold font-robotoSlab">
              {props.title}
            </h3>
            <p className="text-xs">{props.shortContent}</p>
            <span className="text-xs text-orange">
              {new Date(props.publishedAt).toLocaleDateString('pt-BR')}
            </span>
          </div>
        </Link>
      </div>
    </>
  )
}
